import { searchesConfigurationAdapter } from "./searchesConfigurationSlice";

export const {
  selectAll: selectedSearchesConfiguration,
  selectEntities: selectSearchesConfigurationEntities,
  selectById: selectSearchConfigurationById,
  selectTotal: selectSearchesConfigurationCount,
} = searchesConfigurationAdapter.getSelectors<Store.RootState>(
  ({ searchesConfiguration }) => searchesConfiguration,
);

export const selectTemporaryRelatedKeywords = (
  state: Store.RootState,
  searchId: Search.Data["id"],
): Record<string, true> => {
  return state.searchesConfiguration.temporaryRelatedKeywords[searchId] || {};
};

export const hasTemporaryRelatedKeywords = (
  state: Store.RootState,
  searchId: Search.Data["id"],
): boolean => {
  return searchId in state.searchesConfiguration.temporaryRelatedKeywords;
};
